import { useLicensesStore } from "~/stores/licensesstore";

export function useLicenseCountLoader() {
  const licensesStore = useLicensesStore();
  watch(
    () => [
      licensesStore.companyLicenses,
      licensesStore.companyMemberLicenses,
      licensesStore.userLicenses,
    ],
    async () => {
      await licensesStore.loadLicenseCounts();
    },
  );
}
